import { ApiKey, Logout } from '@carbon/icons-react';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { NavbarMenuItem, NavbarSchema } from 'vet-bones/components';

import {
  NAVBAR_AVATAR_MENU,
  NAVBAR_AVATAR_MENU_ITEM,
} from 'src/ui/constants/testIds';
import { useProfile } from 'src/ui/hooks/connection';
import * as copy from 'src/ui/templates/copy';
import { redirectToUrl } from 'src/ui/utils/window';

export const useLaunchpadNavbarAvatarSchema = (): NonNullable<
  NavbarSchema['footer']
>['avatar'] => {
  const { data: profileData } = useProfile();
  const profile = profileData?.profile;
  const history = useHistory();
  const handleLogout = React.useCallback(() => {
    redirectToUrl('/auth/logout');
  }, []);

  const handleManageApiKeys = React.useCallback(() => {
    history.push('/keys');
  }, [history]);

  return React.useMemo(() => {
    if (!profile || !profile.is_authenticated) {
      return undefined;
    }

    const firstName = profile.first_name || profile.username || '';
    const lastName = profile.last_name || '';

    const items: NavbarMenuItem[] = [];

    if (profile.is_voicebox_api_access_enabled) {
      items.push({
        icon: ApiKey,
        label: copy.components.navbar.avatar.menuItems.manageApiTokens,
        onClick: handleManageApiKeys,
        testId: NAVBAR_AVATAR_MENU_ITEM('manage-api-tokens'),
      });
    }

    items.push({
      icon: Logout,
      label: copy.components.navbar.avatar.menuItems.logout,
      onClick: handleLogout,
      testId: NAVBAR_AVATAR_MENU_ITEM('logout'),
    });

    return {
      description: '',
      label: `${firstName} ${lastName}`,
      menuItems: [{ items }],
      testId: NAVBAR_AVATAR_MENU,
      text: `${firstName.slice(0, 1)}${lastName.slice(0, 1)}`,
    };
  }, [handleManageApiKeys, handleLogout, profile]);
};
